import React, { FC, useEffect, useState } from 'react';
import { Icon } from '@blueprintjs/core';
import { Classes, Tooltip2 } from '@blueprintjs/popover2';

type Props = {
  msg: string,
  initialOpenStatus: boolean
}

const CellValidationAlert: FC<Props> = ({ msg, initialOpenStatus }) => {
  const [isOpen, setIsOpen] = useState(initialOpenStatus);
  useEffect(() => {
    if (isOpen){
      setTimeout(() => setIsOpen(false), 1500)
    }
  }, [isOpen]);

  return (
    <Tooltip2
      compact
      intent="danger"
      isOpen={isOpen}
      className={Classes.TOOLTIP2_INDICATOR}
      content={(<span>{msg}</span>)}
    >
      <Icon
        icon="error"
        intent="danger"
        iconSize={12}
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
      />
    </Tooltip2>
  )
}

export default CellValidationAlert;
